<template lang="pug">
.alertTip
  //- v-alert(v-model="active" :type="'warning'" dark)
  v-alert.text-subtitle-2(
    v-if='showType === "success"'
    v-model="active"
    dense
    icon="mdi-check"
    transition="scroll-y-reverse-transition"
    :type="showType") {{ showContent }}

  v-alert.text-subtitle-2(
    v-if='showType === "warning"'
    v-model="active"
    dense
    icon="mdi-alert"
    transition="scroll-y-reverse-transition"
    :type="showType") {{ showContent }}

  v-alert.text-subtitle-2(
    v-if='showType === "error"'
    v-model="active"
    dense
    icon="mdi-close-octagon"
    transition="scroll-y-reverse-transition"
    :type="showType") {{ showContent }}
    
</template>

<script>

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    showType: {
      type: String,
      default: 'success'
    },
    showContent: {
      type: String,
      default: ''
    }
  },
};
</script>

<style lang="scss" scoped>
.alertTip {
  position: fixed;
  right: 50%;
  top: 24px;
  z-index: 99999;
  transform: translateX(50%);
}
</style>
